import { render } from "./OrderAddressCard.vue?vue&type=template&id=6581baa1"
import script from "./OrderAddressCard.vue?vue&type=script&lang=js"
export * from "./OrderAddressCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__